// Calculate dosage for male wellness formula
export function calculateMaleDosage(answers) {
    // 淫羊藿 (3-5g) - 主要定制成分
    let yinyanghou = 3;

    // 基于主要关注点
    if (answers.mainConcern === 'energy') {
        const duration = answers.energyDuration;
        if (duration === '>6months') {
            yinyanghou = 5;
        } else if (duration === '3-6months') {
            yinyanghou = 4;
        } else {
            yinyanghou = 3;
        }

        // 如果有多种体力问题
        const energyIssueCount = answers.energyIssues?.length || 0;
        if (energyIssueCount >= 2) {
            yinyanghou = Math.min(5, yinyanghou + 1);
        }
    } else if (answers.mainConcern === 'sleep') {
        const duration = answers.sleepDuration;
        if (duration === '>6months') {
            yinyanghou = 4;
        } else {
            yinyanghou = 3;
        }
    } else if (answers.mainConcern === 'stress') {
        const duration = answers.stressDuration;
        if (duration === '>6months') {
            yinyanghou = 4;
        } else {
            yinyanghou = 3;
        }
    } else if (answers.mainConcern === 'overall') {
        if (answers.overallStatus === 'obvious_decline') {
            yinyanghou = 4;
        } else {
            yinyanghou = 3;
        }
    }

    // 如果备孕，适当减量
    if (answers.familyPlanning === 'planning_now') {
        yinyanghou = Math.max(3, yinyanghou - 1);
    }

    // 杜仲叶 (1-2g) - 补肝肾、强筋骨
    let duzhongye = 1;

    const hasLowerBack =
        answers.energyIssues?.includes('lower_back') ||
        answers.otherSymptoms?.includes('lower_back_pain');

    if (hasLowerBack) {
        if (answers.lowerBackDetails?.length >= 2) {
            duzhongye = 2;
        } else {
            duzhongye = 1.5;
        }
    } else if (answers.otherSymptoms?.includes('dizziness')) {
        duzhongye = 1.5;
    }

    // 覆盆子 (1-2g) - 固精缩尿
    let fupenzi = 1;

    if (answers.otherSymptoms?.includes('frequent_urination')) {
        fupenzi = 2;
    } else if (answers.constitution?.includes('sweating')) {
        fupenzi = 1.5;
    }

    // 计算总剂量等级
    const total = yinyanghou + duzhongye + fupenzi;
    let level;
    if (total <= 5.5) level = 'light';
    else if (total <= 7) level = 'medium';
    else level = 'heavy';

    return {
        yinyanghou,
        duzhongye,
        fupenzi,
        level,
        total
    };
}

// Determine review status
export function getMaleReviewStatus(answers, dosage) {
    // Red flags
    if (answers.safety && !answers.safety.includes('none')) {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Health risk factors detected, professional review required.'
        };
    }

    if (answers.demographics?.age === 'other') {
        return {
            status: 'red',
            label: 'Professional Review Required',
            message: 'Age factor requires professional confirmation.'
        };
    }

    // Yellow flags
    const duration = answers.energyDuration || answers.sleepDuration || answers.stressDuration;
    if (duration === '>6months') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Long duration of symptoms, priority assessment recommended.'
        };
    }

    if (answers.familyPlanning === 'planning_now') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'During family planning, safety assessment recommended.'
        };
    }

    if (answers.demographics?.age === '56-65') {
        return {
            status: 'yellow',
            label: 'Priority Review',
            message: 'Age factor, priority assessment recommended.'
        };
    }

    // Green
    return {
        status: 'green',
        label: 'Auto Approved',
        message: 'Formula generated, proceeding to production.'
    };
}

// Base formula
export const MALE_BASE_FORMULA = [
    { name: 'Asian ginseng', amount: '2g' },
    { name: 'Cornelian cherry fruit', amount: '2g' },
    { name: 'Goji berry', amount: '3g' },
    { name: 'Mulberry fruit', amount: '2g' },
    { name: 'Chinese yam', amount: '2g' },
    { name: 'Poria Mushroom', amount: '2g' }
];